// Module
var code = `<form-section-field field-title="'Customer type constraint'">
  <multiselect ng-if="\$ctrl.productType !== 'LOAN'"
               items="\$ctrl.customerTypes"
               ng-model="\$ctrl.customerTypeConstraints"
               ng-change="\$ctrl.onChange()"
               label-property="'label'"
               value-property="'value'"
               ng-required="false">
  </multiselect>
  <multiselect ng-if="\$ctrl.productType === 'LOAN'"
               items="\$ctrl.loanCustomerTypes"
               ng-model="\$ctrl.customerTypeConstraints"
               ng-change="\$ctrl.onChange()"
               label-property="'label'"
               value-property="'value'"
               ng-required="false">
  </multiselect>
</form-section-field>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/common/product/customer-type-constraint/customer-type-constraint.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;